import { FormGroup } from '@angular/forms';

import { TemplateVariableValues } from '../../shared/models/product';

type ProductType = 'a2c' | 'rtpc' | 'ufo';

export const PRODUCT_TYPE_NF = 'NF';
export const PRODUCT_TYPE_F = 'F';
export const PRODUCT_TYPE_FM = 'FM';

export const FIELD_SHIPTO_PARTY = 'shipToParty';
export const FIELD_STEEL_GRADE = 'steelGrade';
export const FIELD_FINISHING_LINE = 'finishingLine';
export const FIELD_THICKNESS = 'thicknessValue';
export const FIELD_WIDTH = 'widthValue';
export const FIELD_LENGTH = 'lengthValue';
export const FIELD_USE_PART_REFERENCE = 'usePartReference';
export const FIELD_TEMPLATE_NUMBER = 'templateNumber';
export const FORM_SHEET_CODE = '7';

export const JOIN_STRING_FOR_CONCAT = '##';
export const ORGANIC_COATED_CATEGORY = 'OC';

export const DEFAULT_SERVICE_CODE = '00';
export const RDD_TYPE_WEEK = 'Week';
export const RDD_TYPE_DAY = 'Day';
export const RDD_TYPE_WEEK_VAL = 'W';

export const FIRST_ROW_FIELDS =
[
	FIELD_SHIPTO_PARTY,
	FIELD_STEEL_GRADE,
	FIELD_THICKNESS,
	FIELD_WIDTH,
	FIELD_LENGTH
];

export type TranslationType = 'SIDE' | 'INLINE' | 'NONE' | 'ONLY';

export type VariableFieldUpdated = Map<string, boolean | boolean[]>;

export interface ProductA2c {
	[key: string]: string | undefined;
	a2citemNumber: string;
	a2citemRelease: string;
	configurationNumber?: string;
	productCategoryCode: string;
	productSubCategoryCode: string;
	productFormCode: string;
	commercialSteelGradeID: string;
	thicknessValue?: string;
	thicknessUnit: string;
	widthValue?: string;
	widthUnit: string;
	commercialSteelGradeIDDescription: string;
	type: ProductType;
	customerTemplateNumber: string;
	customerTemplateReference: string;
	userPartReference: string;
	productType: string;
	commercialMetallicCoatingIDDescription: string;
	dimension: string;
	surfaceAspect: string;
	organicCoatingDataSheet: string;
	colourTop: string;
	removableFilm: string;
	organicCoatingDataSheetBottom: string;
	colorBottom: string;
	chemicalTreatment?: string;
	organicDatasheetNameTop?: string;
	strippableFilmType?: string;
	organicDatasheetNameBottom?: string;
	colourBottom?: string;
	edgeTrimmedInLastToolCodeDescription?: string;
	floorPlatesPattern?: string;
	floorPlatesPatternSide?: string;
	strippableFilmSide?: string;
	streakinessMaxInMicron?: string;
	betterSidePosition?: string;
	commercialThicknessToleranceIDDescription?: string;
	thicknessToleranceMinus?: string;
	thicknessTolerancePlus?: string;
	varnishTop?: string;
	varnishBottom?: string;
	primerTop?: string;
	primerBottom?: string;
	commercialTOCTypeTopID?: string;
	commercialTOCTypeTopIDDescription?: string;
	commercialTOCTypeBottomID?: string;
	commercialTOCTypeBottomIDDescription?: string;
	nominalThicknessValueBottom?: string;
	nominalThicknessValueTop?: string;
	unitOfDimensions?: string;
	lengthValue?: string;
	lengthUnit?: string;
	lastUsed?: string;
	emptyRow?: string;
	productRequestId?: string;
	productRef?: string;
	configurationRef?: string;
	quantity?: string;
	inquiryNumber?: string;
}

export interface TemplateDescription {
	templateNumber: number;
	templateRelease: number;
	properties: Record<string, TemplateVariable>;
	customerTemplateReference: string;
	listOfVariables: string[];
}

export interface TemplateVariableArray extends TemplateVariable {
	properties: Record<string, TemplateVariable>;
	maxItems: number;
}

export interface TemplateVariable {
	type: 'string' | 'integer' | 'number' | 'array' | 'group';
	properties?: Record<string, TemplateVariable>;
	path: string;
	mandatory: boolean;
	hidden: boolean;
	free?: boolean;
	order?: number;
}

export interface TemplateVariableString extends TemplateVariable {
	maxLength: number;
	free: boolean;
}

export interface VariableField extends TemplateVariableValues {
	keys: string;
}

export interface RequestOrder {
	id?: number;
	soldToRef: string;
	purchaseOrderNumber?: string;
	comments?: string;
	listOfRequestOrderItem?: RequestOrderItem[];
	invoicingCurrencyTr?: string;
	codeUnitRef?: string;
	codeSubUnitRef?: string;
	codeSubSubUnitRef?: string;
}

export interface RequestOrderItem {
	id?: number;
	requestOrderId?: number;
	itemNumber?: string;
	productRef: string;
	connectionKey?: string;
	configurationRef?: string;
	templateRef: string;
	productStatusTr?: string;
	soldToRef: string;
	shipToRef?: string;
	transportModeTr: string;
	xcarb?: string;
	businessType?: string;
	deliveryDateTypeTr?: string;
	deliveryDate?: Date | string;
	deliveryDateDisplay?: string;
	incotermTr?: string;
	incoterm2Tr?: string;
	quantityAmount: number;
	quantityUnitTr: string;
	priceAmount?: number;
	priceCurrencyTr?: string;
	priceWeightTr?: string;
	endUserRef?: string;
	totalAmount?: number;
	totalUnitTr?: string;
	productType?: string;
	listOfRequestProductData?: RequestProductData[];
	listOfRequestServiceLevel?: RequestServiceLevel[];
}

export interface RequestProductData {
	id?: number;
	requestOrderItemId?: number;
	characName: string;
	type: string;
	characValueText?: string;
	characValueUnitTr?: string;
	characValueTable?: string;
	characterDescription?: string;
	characValueNum?: number;
	modificationDate?: Date;
	modificationBy?: string;
}

export interface RequestServiceLevel {
	id?: number;
	requestOrderItemId?: number;
	serviceLevelRef?: string;
}

export interface AddToCartResponse {
	itemAdded: boolean;
	allowAfterConfirmation: boolean;
	messages: string[];
}

export interface BocClient {
	businessId: string;
	name: string;
	city: string;
}

export interface Eorder {
	header: EorderHeader;
	products?: EorderProduct[] | undefined;
}

interface EorderHeader extends BocOpt, OrderHeaderId {
	customerOrderNumber?: string;
	soldTo?: string;
	shipTo?: string;
}

interface OrderHeaderId {
	id?: number | undefined;
	externalId?: string | undefined;
}

export interface BocOpt {
	soldTo?: string;
	shipTo?: string;
	endUser?: string | undefined;
}

export interface EorderProduct {
	a2citemNumber?: string | undefined;
	inquiryNumber?: string | undefined;
	quantity?: number | undefined;
	steelGrade?: string | undefined;
	steelGradeDescription?: string | undefined;
	thicknessValue?: number | undefined;
	widthValue?: number | undefined;
	lengthValue?: number | undefined;
	rddType?: string | undefined;
	rdd?: string | undefined;
	shipToParty?: string | undefined;
	transportMode?: string;
	serviceLevel?: string;
	xcarb?: string;
	templateNumber?: number;
	businessType?: string;
	productType?: string;
	configurationNumber?: number;
	isSimulationCompleted?: string;
	configErrMsg?: string;
	loader?: string;
	variableFormGroup?: FormGroup;
}

export type FieldOfOrderDraft = keyof OrderDraft;

export interface OrderDraft {
	orderID?: number;
	customerOrderNumber?: number;
	listOfProductFamily?: ProductFamily[];
	noOfProducts?: number;
	totalQuantity?: number;
	creationDate?: Date;
	creatorName?: string;
	creatorID?: string;
	modificationDate?: Date;
}

export interface ProductFamily {
	code: string;
	category: string;
	categoryDescription: string;
	subCategory: string;
	subCategoryDescription: string;
	form: string;
	formDescription: string;
	customerTemplate: Template[];
}

interface Template {
	customerTemplateNumber?: number;
	productType?: string;
}

export interface DraftOrderItem extends OfferProductId {
	id?: number | undefined;
	quantityAmount: number;
	shipToRef?: string | undefined;
	templateRef?: string | undefined;
	deliveryDateTypeTr?: string;
	deliveryDate?: string | undefined;
	deliveryDateDisplay?: string | undefined;
	transportModeTr: string;
	listOfRequestProductData?: RequestProductData[];
	listOfRequestServiceLevel?: RequestServiceLevel[];

}

interface OfferProductId {
	id?: number | undefined;
	externalId?: string | undefined;
}

export interface Partner {
	businessPartnerNumber?: string;
	customerPackagingPeriodWinterFromPeriod?: string;
	customerPackagingPeriodWinterToPeriod?: string;
	customerPackagingPeriodSummerFromPeriod?: string;
	customerPackagingPeriodSummerToPeriod?: string;
	addressCountry?: string;
	customerDestinationByTruck?: string;
	customerDestinationByTrain?: string;
	customerDestinationByBoat?: string;
}

export type FieldOfPartner = keyof Partner;
